<template>
  <div>
    <base-header :style="{ background: '#F7F8FD' }" class="py-6">
      <div class="row"></div>
    </base-header>
    <div class="container-fluid">
      <v-app>
        <card>
          <div class="row align-items-center p-3">
            <h2 class="col-6 m-0">Distributors</h2>
            <div class="col-6 text-end">
              <v-btn
                class="mx-2"
                fab
                @click.prevent="add = !add"
                dark
                small
                color="#4D4B4B"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </div>
          </div>

          <div class="col-6">
            <v-text-field
              label="Search"
              v-model="search"
              append-icon="mdi-magnify"
            ></v-text-field>
          </div>

          <div class="table-responsive mt-4">
            <base-table
              class="align-items-center"
              thead-classes="thead-light"
              type="hover"
              :data="filteredList"
            >
              <template slot="columns">
                <th v-for="(header, index) in tableHeaders" :key="index">
                  {{ header }}
                </th>
              </template>
              <template slot-scope="{ row, index }">
                <td>{{ index + 1 }}</td>
                <td>{{ row.name }}</td>
                <td>{{ row.location }}</td>
                <td>{{ row.number }}</td>
                <td>
                  {{
                    row.routes
                      .map(
                        (item) =>
                          routeList.find((route) => route.id === item).name
                      )
                      .join(", ")
                  }}
                </td>
                <td>
                  <!-- <i class="btn fas fa-eye" @click.prevent="viewProperty"></i> -->
                  <i class="btn fas fa-pen" @click="editDistributor(row.id)"></i
                  ><i
                    class="btn fas fa-trash text-danger"
                    @click.prevent="deleteDistributor({ row, index })"
                  ></i>
                </td>
              </template>
            </base-table>
          </div>
          <delete-dialog
            :data="distributorsList"
            v-model="deleteItemIndex"
            actionString="deleteDistributor"
            item="distributor"
            :miscData="{ itemID: selectedItem }"
          >
            <span slot="warning">This distributor data will be removed! </span>
          </delete-dialog>
        </card>
      </v-app>
    </div>
    <AddDistributor :dialog.sync="add" />
    <EditDistributor :dialog.sync="edit" :id.sync="selectedItem" />
  </div>
</template>
<script>
import AddDistributor from "./AddDistributor.vue";
import EditDistributor from "./EditDistributor.vue";

export default {
  name: "Distributors",
  components: {
    AddDistributor,
    EditDistributor,
  },
  data() {
    return {
      add: false,
      edit: false,
      deleteItemIndex: -1,
      selectedItem: null,
      filteredList: [],
      search: "",
      tableHeaders: [
        "SL",
        "Name",
        "Location",
        "Contact Number",
        "Routes",
        "Actions",
      ],
    };
  },
  methods: {
    editDistributor(id) {
      this.selectedItem = id;
      this.edit = !this.edit;
    },
    deleteDistributor({ row, index }) {
      this.deleteItemIndex = index;
      this.selectedItem = row.id;
    },
    fetchDistributorList() {
      this.$store.dispatch("fetchDistributorList").catch((err) => {
        this.$notify({
          title: "Failed to fetch distributors list",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: err.toString(),
        });
      });
    },
    fetchRouteList() {
      this.$store.dispatch("fetchRouteList").catch((err) => {
        this.$notify({
          title: "Failed to fetch route list",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: err.toString(),
        });
      });
    },
  },
  computed: {
    distributorsList() {
      return this.$store.state.distributorStore.distributors;
    },
    routeList() {
      return this.$store.state.routeStore.routes;
    },
  },
  watch: {
    add() {
      this.fetchDistributorList();
    },
    edit() {
      this.fetchDistributorList();
    },
    distributorsList() {
      this.filteredList = [...this.distributorsList];
    },
    search() {
      if (this.search.trim() !== "") {
        this.filteredList = this.distributorsList.filter((item) =>
          item.name.toUpperCase().includes(this.search.toUpperCase())
        );
      } else {
        this.filteredList = [...this.distributorsList];
      }
    },
  },
  mounted() {
    this.fetchRouteList();
    this.fetchDistributorList();
  },
};
</script>
<style scoped>
.test {
  color: blue;
}

.test:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
